import { observer } from 'mobx-react';

import { useStores } from '../../../../stores/useStores';
import { useMetagameWidgetData } from '../../hooks/useMetagameWidgetData';
import type { PrizeDropWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { PrizeDropWidgetTimer } from './PrizeDropWidgetTimer/PrizeDropWidgetTimer';

interface PrizeDropWidgetProps {
  sizeType: WidgetSizeType;
  data: PrizeDropWidgetDataType;
}

function PrizeDropWidgetComponent(props: PrizeDropWidgetProps) {
  const { coinTypeStore } = useStores();
  const coinType = coinTypeStore.coinType;
  const { data, sizeType } = props;
  const { event } = data;
  const eventByCoin = event[coinType.toLowerCase() as 'gc' | 'sc'];
  const { widgetImageUrl, onTimerEnd, handleClick } = useMetagameWidgetData({ event, eventByCoin });

  if (!eventByCoin || !widgetImageUrl) {
    return null;
  }

  const timer = (
    <PrizeDropWidgetTimer endDate={new Date(event.endDate)} extended={sizeType === 'wide'} onEnd={onTimerEnd} />
  );

  return (
    <WidgetWrapper smallWidgetExtended dataTestId="prize-drop-widget" sizeType={sizeType} onClick={handleClick}>
      {sizeType === 'small' ? (
        <GeneralSmallWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const PrizeDropWidget = observer(PrizeDropWidgetComponent);
